/**
 * One URL per wizard step (B17). Deliberately renders nothing: the wizard is
 * the PARENT route's component (`/_shell/onboarding`), which stays mounted
 * while this param changes, so moving between steps never re-runs the
 * bootstrap. The page reads the slug as `router.query.step`.
 */
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/onboarding/$step')({})
